import React, { useEffect, useRef, useState } from 'react'
import { Accordion, Button, Form, Card, Row, Col, Container, Badge, Modal } from 'react-bootstrap'
import upload from '../../assets/images/Paper Upload.png'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Loader from '../../components/loader/loader';
import {
  createManufacturer,
  getManufacturerDetails,
  statusUpdateTiming,
  updateManufacturer,
} from '../../api/context/manufacturer'
import toast from 'react-hot-toast'
import * as yup from 'yup'
import { useFormik } from 'formik'
import imageToBase64 from 'image-to-base64/browser'
import { uploadBulkProducts } from '../../api/context/products'
import { Switch } from '@mui/material'
import { MdOutlineUploadFile } from 'react-icons/md'
import sampleFile from '../../assets/files/sample-sheet.xlsx'
import { useRecoilState } from 'recoil'
import { updateDetailsState } from '../../atoms/updateDetails'
import { BsDownload, BsEye, BsEyeSlash, BsInfoCircle, BsX } from 'react-icons/bs'
import { IoMdArrowBack } from 'react-icons/io'
import GoogleMap from 'google-map-react'
import AsyncSelect from 'react-select/async';
import GooglePlacesAutocomplete, {
  geocodeByPlaceId,
  getLatLng,
} from 'react-google-places-autocomplete'
import { FaMapMarkerAlt, FaCheckDouble } from 'react-icons/fa'
import { GOOGLE_MAP_API_KEY } from '../../utils/config'
import { FiUploadCloud, FiCheck } from 'react-icons/fi'
import { getBrandListing } from '../../api/context/brand'
import { Verified } from '@mui/icons-material'
import ErrorState from '../../components/Error/errorState';


const CreateManufacturer = () => {
  const navigate = useNavigate()

  const { id } = useParams()

  const user = JSON.parse(localStorage.getItem('user'))

  console.log(user, 'user is here')

  const [dataLoading, setDataLoading] = useState(false)
  const [dataError, setDataError] = useState(false)
  const [activeSection, setActiveSection] = useState('basic');

  const VFP_SECTIONS = [
    { key: 'basic',    label: 'Basic Info', shortLabel: 'Basic' },
    { key: 'location', label: 'Location',   shortLabel: 'Location' },
    { key: 'business', label: 'Business',   shortLabel: 'Business' },
    { key: 'bank',     label: 'Bank',       shortLabel: 'Bank' },
    { key: 'timings',  label: 'Timings',    shortLabel: 'Timings' },
  ];
  const activeSectionIndex = VFP_SECTIONS.findIndex(s => s.key === activeSection);
  const goNextSection = () => {
    const next = VFP_SECTIONS[Math.min(activeSectionIndex + 1, VFP_SECTIONS.length - 1)];
    if (next?.key) setActiveSection(next.key);
  };
  const goPrevSection = () => {
    const prev = VFP_SECTIONS[Math.max(activeSectionIndex - 1, 0)];
    if (prev?.key) setActiveSection(prev.key);
  };


  const [page, setPage] = useState(1);
  const [brands, setBrands] = useState([]);
  const [brandError, setBrandError] = useState(false);

  const [selectedBrands, setSelectedBrands] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  let typingTimer;



  const [selectedFiles, setSelectedFiles] = useState([])
  const [loading, setLoading] = useState(false)
  const [update, setUpdate] = useState(false)
  const [store, setStore] = useState([])
  const [bulkLoading, setBulkLoading] = useState(false)
  const [bulkModal, setBulkModal] = useState(false)
  const [refresh, setRefresh] = useRecoilState(updateDetailsState)
  const [showaccnumber, setShowAccnumber] = useState({
    accountNumber: false,
    reaccountNumber: false,
  })
  const [script, setScript] = useState(false)
  const [value, setValue] = useState(null)
  const [mapCenter, setMapCenter] = useState({ lat: 28.461272, lng: 77.026825 })

  // Tracks which button the admin clicked so the payload / spinner label can react.
  // Ref (not state) so the value is visible inside the async onSubmit that fires
  // immediately after formik.submitForm().
  const submitIntentRef = useRef('update')
  const [loadingIntent, setLoadingIntent] = useState(null)

  const triggerSubmit = async (intent) => {
    submitIntentRef.current = intent

    // Validate up front so a failing yup schema doesn't leave the button spinning.
    const errors = await formik.validateForm()
    if (Object.keys(errors).length > 0) {
      const touched = Object.keys(errors).reduce((acc, k) => ({ ...acc, [k]: true }), {})
      formik.setTouched({ ...formik.touched, ...touched })
      toast.error('Some required fields are missing or invalid')
      return
    }

    setLoadingIntent(intent)
    formik.submitForm()
  }

  const toggleaccountNumberVisibility = (fieldName) => {
    setShowAccnumber((prev) => ({ ...prev, [fieldName]: !prev[fieldName] }))
  }

  const [previewImage, setPreviewImage] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  const openPreview = (img) => {
    setPreviewImage(img);
    setShowPreview(true);
  };

  const closePreview = () => {
    setPreviewImage(null);
    setShowPreview(false);
  };





  const handleFileChange = (event) => {
    const files = event.target.files
    setSelectedFiles(files)
  }

  const validationSchema = yup.object().shape({
    storeName: yup
      .string()
      .required('Store name is required')
      .min(2, 'Store name must be at least 2 characters')
      .max(100, 'Store name cannot exceed 100 characters'),

    // img_view: yup.string().required('Store image is required'),
    // pan_copy_view: yup.string().required('PAN copy image is required'),
    // gst_copy_view: yup.string().required('GST copy image is required'),
    // cancelled_cheque_view: yup.string().required('Cancelled cheque image is required'),

    ownerName: yup
      .string()
      .required('Owner name is required')
      .min(2, 'Owner name must be at least 2 characters')
      .max(50, 'Owner name cannot exceed 50 characters'),

    phoneNumber: yup
      .string()
      .matches(/^[1-9][0-9]{9}$/, 'Mobile number must be 10 digits, cannot start with 0, and contain only numbers')
      .required('Phone number is required'),

    email: yup
      .string()
      .email('Enter a valid email address')
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        'Enter a valid email address'
      )
      .required('Email is required')
      .max(100, 'Email cannot exceed 100 characters'),

    commission: yup
      .number()
      .typeError('Commission must be a number')
      .min(0, 'Commission cannot be negative')
      .max(100, 'Commission cannot exceed 100%')
      .required('Commission is required'),

    address: yup
      .string()
      .required('Address is required')
      .min(5, 'Address must be at least 5 characters')
      .max(200, 'Address cannot exceed 200 characters'),

    state: yup
      .string()
      .matches(/^[a-zA-Z\s]+$/, 'State can only contain letters and spaces')
      .required('State is required')
      .min(2, 'State must be at least 2 characters')
      .max(50, 'State cannot exceed 50 characters'),

    city: yup
      .string()
      .matches(/^[a-zA-Z\s]+$/, 'City can only contain letters and spaces')
      .required('City is required')
      .min(2, 'City must be at least 2 characters')
      .max(50, 'City cannot exceed 50 characters'),

    landmark: yup
      .string()
      .transform((val) => (val === '' ? undefined : val))
      .min(2, 'Landmark must be at least 2 characters')
      .max(100, 'Landmark cannot exceed 100 characters'),

    postalcode: yup
      .string()
      .matches(/^[1-9][0-9]{5}$/, 'Enter a valid 6-digit PinCode')
      .required('PinCode is required'),

    businessName: yup
      .string()
      .matches(/^[a-zA-Z0-9\s\-&.,]+$/, 'Business name can only contain letters, numbers, spaces, and basic punctuation')
      // .required('Business name is required')
      .min(2, 'Business name must be at least 2 characters')
      .max(100, 'Business name cannot exceed 100 characters'),

    bankName: yup
      .string()
      .transform((val) => (val === '' ? undefined : val))
      .matches(/^[a-zA-Z0-9\s\-&.,]+$/, 'Bank name can only contain letters, numbers, spaces, and basic punctuation')
      .min(2, 'Bank name must be at least 2 characters')
      .max(100, 'Bank name cannot exceed 100 characters'),

    accountType: yup
      .string()
      .transform((val) => (val === '' ? undefined : val))
      .matches(/^[a-zA-Z\s]+$/, 'Account type can only contain letters and spaces'),

    accountHolderName: yup
      .string()
      .transform((val) => (val === '' ? undefined : val))
      .matches(/^[a-zA-Z\s.'-]+$/, 'Account holder name can only contain letters, spaces, apostrophes, and hyphens')
      .min(2, 'Account holder name must be at least 2 characters')
      .max(50, 'Account holder name cannot exceed 50 characters'),

    accountNumber: yup
      .string()
      .transform((val) => (val === '' ? undefined : val))
      .matches(/^[0-9]+$/, 'Account number must contain only numbers')
      .min(9, 'Account number must be at least 9 digits')
      .max(18, 'Account number cannot exceed 18 digits'),


    reaccountNumber: yup
      .string()
      .transform((val) => (val === '' ? undefined : val))
      .oneOf([yup.ref('accountNumber'), null], 'Account numbers must match'),

    ifscCode: yup
      .string()
      .transform((val) => (val === '' ? undefined : val)),

    gst: yup
      .string()
      .transform((val) => (val === '' ? undefined : val))
      .length(15, 'GST must be 15 characters'),

    pan: yup
      .string()
      .transform((val) => (val === '' ? undefined : val))
      // .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Enter a valid PAN number (e.g., ABCDE1234F)')
      .length(10, 'PAN must be 10 characters'),
  });

  const formik = useFormik({
    initialValues: {
      storeName: '',
      image: '',
      pan_copy_image: '',
      gst_copy_image: '',
      cancelled_cheque_image: '',
      img_view: '',
      pan_copy_view: '',
      gst_copy_view: '',
      cancelled_cheque_view: '',
      businessName: '',
      ownerName: '',
      phoneNumber: '',
      email: '',
      address: '',
      state: '',
      city: '',
      postalcode: '',
      landmark: '',
      description: '',
      pan: '',
      gst: '',
      gstApplicable: false,
      commission: '',
      bankName: '',
      accountType: '',
      accountHolderName: '',
      accountNumber: '',
      reaccountNumber: '',
      ifscCode: '',
      latitude: '',
      longitude: '',
      place_id: '',
      brandIds: [],
      selectedBrands: [],
      storeTimings: [
        {
          day: 'Monday',
          openingTime: '10:00',
          closingTime: '22:00',
          isActive: true,
        },
        {
          day: 'Tuesday',
          openingTime: '10:00',
          closingTime: '22:00',
          isActive: true,
        },
        {
          day: 'Wednesday',
          openingTime: '10:00',
          closingTime: '22:00',
          isActive: true,
        },
        {
          day: 'Thursday',
          openingTime: '10:00',
          closingTime: '22:00',
          isActive: true,
        },
        {
          day: 'Friday',
          openingTime: '10:00',
          closingTime: '22:00',
          isActive: true,
        },
        {
          day: 'Saturday',
          openingTime: '10:00',
          closingTime: '22:00',
          isActive: true,
        },
        {
          day: 'Sunday',
          openingTime: '10:00',
          closingTime: '22:00',
          isActive: false,
        },
      ],
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      if (selectedBrands.length === 0) {
        setBrandError(true);
        setLoadingIntent(null);
        return;
      } else {
        setBrandError(false);
      }
      setLoading(true)


      const brandIds = selectedBrands.map(brand => brand.value);

      const isVerifyAction =
        id &&
        user?.userType === 'ADMIN' &&
        !store?.isVerified &&
        submitIntentRef.current === 'verify'

      // delete values.reaccountNumber;
      const { reaccountNumber, ...rest } = values
      const data = {
        ...rest,
        brandIds,
        // Only sent when the admin explicitly clicks "Verify Vendor" on an unverified vendor.
        ...(isVerifyAction ? { isVerified: true } : {}),
      }

      try {
        if (id) {
          updateManufacturer(data)((response) => {
            if (response?.data?.statusCode == 200) {
              if (values.image == '') {
                delete values.image
              }
              if (values.pan_copy_image == '') {
                delete values.pan_copy_image
              }
              if (values.gst_copy_image == '') {
                delete values.gst_copy_image
              }
              if (values.cancelled_cheque_image == '') {
                delete values.cancelled_cheque_image
              }
              delete values.img_view;
              delete values.pan_copy_view;
              delete values.gst_copy_view;
              delete values.cancelled_cheque_view;
              delete values.selectedBrands;
              setLoading(false)
              setLoadingIntent(null)
              setRefresh(!refresh)
              resetForm()
              toast.success(isVerifyAction ? 'Vendor verified successfully' : 'Store Updated Successfully')
              if (user?.userType === 'Vendor') {
                navigate('/my-profile')
              } else {
                navigate('/vendors')
              }
            } else {
              setLoading(false)
              setLoadingIntent(null)
              toast.error(response?.data?.message)
            }
          })
        } else {
          createManufacturer(data)((response) => {
            if (response?.data?.statusCode == 200) {
              setLoading(false)
              setLoadingIntent(null)
              if (bulkFormik?.values?.file) {
                handlebulkSubmit(
                  bulkFormik?.values?.file,
                  response?.data?.data?.id
                )
              } else {
                toast.success('Store Created Successfully')
                navigate('/vendors')
              }
              // handlebulkSubmit(bulkFormik.values.file, response?.data?.data?.id)
              // bulkFormik.submitForm();
            } else {
              setLoading(false)
              setLoadingIntent(null)
              formik.setErrors({
                email: response?.data?.message,
              })
              toast.error(response?.data?.message)
            }
          })
        }
      } catch (error) {
        console.error(error)

        setLoading(false)
        setLoadingIntent(null)
      }
    },
  })


  const bulkFormik = useFormik({
    initialValues: {
      file: '',
      filename: '',
    },
    validationSchema: yup.object().shape({
      file: yup.string('').required('Required'),
    }),
    onSubmit: async (values, { resetForm }) => {
      setLoading(true)
      setBulkLoading(true)
      try {
        console.log(values)
        let formData = new FormData()
        formData.append('file', values.file)
        uploadBulkProducts(formData)((response) => {
          if (response && response?.data?.statusCode == 200) {
            setLoading(false)
            setBulkLoading(false)
            setBulkModal(false)
            resetForm()
            toast.success('Store Created Successfully')
            navigate('/vendors')
          } else {
            setLoading(false)
            setBulkLoading(false)
            toast.error(response?.data?.message)
          }
        })
      } catch (error) {
        console.error(error)
        toast.error('something went wrong!, please try again', 'error')
        setLoading(false)
        setBulkLoading(false)
      }
    },
  })

  const handlebulkSubmit = (file, man_id) => {
    let formData = new FormData()
    formData.append('manufacturerId', man_id)
    formData.append('file', file)
    uploadBulkProducts(formData)((response) => {
      if (response && response?.data?.statusCode == 200) {
        setLoading(false)
        setBulkLoading(false)
        setBulkModal(false)
        toast.success('Store Created Successfully')
        navigate('/vendors')
      } else {
        setLoading(false)
        setBulkLoading(false)
        toast.error(response?.data?.message)
      }
    })
  }

  const handleImageChange = async (e) => {
    const file = e?.target?.files[0];
    const inputId = e?.target?.id;

    if (!file) return;

    try {
      const response = await imageToBase64(URL.createObjectURL(file));
      const base64Image = 'data:image/jpeg;base64,' + response;

      const fieldMap = {
        storeImage: { imageField: 'image', previewField: 'img_view' },
        panCopy: { imageField: 'pan_copy_image', previewField: 'pan_copy_view' },
        gstCopy: { imageField: 'gst_copy_image', previewField: 'gst_copy_view' },
        cancelledChequeCopy: { imageField: 'cancelled_cheque_image', previewField: 'cancelled_cheque_view' }
      };

      const fieldConfig = fieldMap[inputId];

      if (fieldConfig) {
        formik.setValues({
          ...formik.values,
          [fieldConfig.imageField]: base64Image,
          [fieldConfig.previewField]: base64Image,
        });

        // Clear any previous validation errors for this field
        formik.setFieldTouched(fieldConfig.imageField, true, false);
      }
    } catch (error) {
      console.error('Error processing image:', error);
      toast.error('Failed to process image. Please try again.');
    }
  };


  const statusActive = (timeid, active, index) => {
    console.log(timeid, active)
    if (id) {
      statusUpdateTiming({ timingId: timeid, isActive: !active })(
        (response) => {
          if (response?.status == 200) {
            setUpdate(!update)
          } else {
          }
        }
      )
    } else {
      const updatedStoreTimings = formik.values.storeTimings
      updatedStoreTimings[index].isActive = !active
      formik.setValues({
        ...formik.values,
        storeTimings: updatedStoreTimings,
      })
    }
  }

  const formatTime = (timeString) => {
    const time = new Date(`1970-01-01T${timeString}`)

    const hours = time.getHours().toString().padStart(2, '0')
    const minutes = time.getMinutes().toString().padStart(2, '0')

    return `${hours}:${minutes}`
  }

  const getManufacturer = async () => {
    setDataLoading(true)
    setDataError(false)

    getManufacturerDetails(id)(async (response) => {
      if (response?.data?.statusCode == 200) {
        const manufacturer = response?.data?.data[0]
        // Prefer VendorBrands if present, fallback to Brands
        let initialSelectedBrands = [];
        if (manufacturer.VendorBrands && manufacturer.VendorBrands.length > 0) {
          initialSelectedBrands = manufacturer.VendorBrands
            .map(vb => vb.Brand ? { value: vb.Brand.id, label: vb.Brand.name } : null)
            .filter(Boolean);
        } else if (manufacturer.Brands && manufacturer.Brands.length > 0) {
          initialSelectedBrands = manufacturer.Brands.map(brand => ({
            value: brand.id,
            label: brand.name,
          }));
        }

        setSelectedBrands(initialSelectedBrands);


        formik.setValues((prevState) => ({
          ...prevState,
          id: id,
          place_id: manufacturer?.place_id || '',
          storeName: manufacturer?.storeName ? manufacturer?.storeName : '',
          ownerName: manufacturer?.ownerName ? manufacturer?.ownerName : '',
          // image: manufacturer?.image ? manufacturer?.image : '',
          img_view: manufacturer?.image ? manufacturer?.image : '',
          businessName: manufacturer?.VendorBankDetails[0]?.businessNameAsPerGST ? manufacturer?.VendorBankDetails[0]?.businessNameAsPerGST : '',
          pan_copy_view: manufacturer?.VendorBankDetails[0]?.panCopy ? manufacturer?.VendorBankDetails[0]?.panCopy : '',
          gst_copy_view: manufacturer?.VendorBankDetails[0]?.gstCopy ? manufacturer?.VendorBankDetails[0]?.gstCopy : '',
          cancelled_cheque_view: manufacturer?.VendorBankDetails[0]?.cancelledChequeCopy ? manufacturer?.VendorBankDetails[0]?.cancelledChequeCopy : '',

          phoneNumber: manufacturer?.phoneNumber
            ? manufacturer?.phoneNumber
            : '',
          gstApplicable: manufacturer?.gstApplicable
            ? manufacturer?.gstApplicable
            : false,
          pan: manufacturer?.VendorBankDetails[0]?.pan
            ? manufacturer?.VendorBankDetails[0]?.pan
            : '',
          gst: manufacturer?.VendorBankDetails[0]?.gst
            ? manufacturer?.VendorBankDetails[0]?.gst
            : '',
          commission: manufacturer?.commission ?? '',

          email: manufacturer?.email ? manufacturer?.email : '',
          address: manufacturer?.address ? manufacturer?.address : '',
          state: manufacturer?.state ? manufacturer?.state : '',
          city: manufacturer?.city ? manufacturer?.city : '',
          description: manufacturer?.description
            ? manufacturer?.description
            : '',
          landmark: manufacturer?.landmark ? manufacturer?.landmark : '',
          postalcode: manufacturer?.postalcode ? manufacturer?.postalcode : '',
          latitude: manufacturer?.latitude ? manufacturer?.latitude : '',
          longitude: manufacturer?.longitude ? manufacturer?.longitude : '',
          bankName: manufacturer?.VendorBankDetails[0]?.bankName
            ? manufacturer?.VendorBankDetails[0]?.bankName
            : '',
          accountType: manufacturer?.VendorBankDetails[0]?.accountType
            ? manufacturer?.VendorBankDetails[0]?.accountType
            : '',
          accountHolderName: manufacturer?.VendorBankDetails[0]
            ?.accountHolderName
            ? manufacturer?.VendorBankDetails[0]?.accountHolderName
            : '',
          accountNumber: manufacturer?.VendorBankDetails[0]?.accountNumber
            ? manufacturer?.VendorBankDetails[0]?.accountNumber
            : '',
          reaccountNumber: manufacturer?.VendorBankDetails[0]?.accountNumber
            ? manufacturer?.VendorBankDetails[0]?.accountNumber
            : '',
          ifscCode: manufacturer?.VendorBankDetails[0]?.ifscCode
            ? manufacturer?.VendorBankDetails[0]?.ifscCode
            : '',
          storeTimings: manufacturer?.StoreTimings
            ? manufacturer.StoreTimings
            : prevState.storeTimings,

          selectedBrands: initialSelectedBrands,
          brandIds: initialSelectedBrands.map(brand => brand.value),


        }))


        // Set the GooglePlacesAutocomplete value for edit mode
        // In getManufacturer function, update the value setting:
        setValue(
          manufacturer?.place_id && manufacturer?.address
            ? {
              label: manufacturer.address,
              value: {
                place_id: manufacturer.place_id,
                description: manufacturer.address
              }
            }
            : null
        )

        // Set the map center with latitude and longitude
        setMapCenter({
          lat: manufacturer?.latitude ?? 0,
          lng: manufacturer?.longitude ?? 0,
        })
        setStore(manufacturer)
        setDataLoading(false)

      } else {
        setDataError(true)
        setStore([])
        setDataLoading(false)

      }
    })

  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    const trimmedValue = value.replace(/^\s+/, '')
    formik.setFieldValue(name, trimmedValue)
  }

  useEffect(() => {
    if (id) {
      // setLoading(true)
      getManufacturer()
    }
  }, [update, id])

  useEffect(() => {
    const existingScript = document.getElementById('googleMaps')
    if (!existingScript) {
      const script = document.createElement('script')
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places`
      script.id = 'googleMaps'
      document.body.appendChild(script)
      script.onload = () => setScript(true)
    } else {
      setScript(true)
    }
  }, [GOOGLE_MAP_API_KEY])

  const changeValue = async (value) => {
    setValue(value)
    try {
      const results = await geocodeByPlaceId(value?.value?.place_id)
      const location = results[0]
      const { lat, lng } = await getLatLng(location)

      setMapCenter({ lat, lng })
      formik.setFieldValue('latitude', lat)
      formik.setFieldValue('longitude', lng)
      formik.setFieldValue('place_id', value?.value?.place_id)

      // Extract address components
      const addressComponents = location?.address_components || []
      const address = location?.formatted_address || ''

      const getComponent = (type) =>
        addressComponents.find((component) => component.types.includes(type))
          ?.long_name || ''

      const state = getComponent('administrative_area_level_1')
      const city =
        getComponent('locality') || getComponent('administrative_area_level_2')
      const postalcode = getComponent('postal_code')

      formik.setFieldValue('address', address)
      formik.setFieldValue('state', state)
      formik.setFieldValue('city', city)
      formik.setFieldValue('postalcode', postalcode)
    } catch (error) {
      console.error('Error fetching location coordinates:', error)
    }
  }

  const handleMapClick = ({ lat, long }) => {
    console.log(lat, long)

    mapCenter({ lat, long })
    formik.setFieldValue('latitude', lat)
    formik.setFieldValue('longitude', long)
  }

  // Disable browser autofill on all inputs rendered inside the vendor form.
  // Form is rendered conditionally after data loads, so we re-apply when
  // dataLoading flips (and once more on a short delay for any late mounts).
  useEffect(() => {
    const applyNoAutofill = () => {
      const inputs = document.querySelectorAll('.cm-no-autofill input, .cm-no-autofill select, .cm-no-autofill textarea');
      inputs.forEach((el) => {
        el.setAttribute('autocomplete', 'one-time-code');
        el.setAttribute('autocorrect', 'off');
        el.setAttribute('spellcheck', 'false');
      });
    };
    applyNoAutofill();
    const t = setTimeout(applyNoAutofill, 300);
    return () => clearTimeout(t);
  }, [dataLoading]);

  useEffect(() => {
    fetchBrands('', 1);
  }, [])

  const downloadImage = (imageSrc, filename = 'document') => {
    if (!imageSrc) return;

    const link = document.createElement('a');
    link.href = imageSrc;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const fetchBrands = (inputValue, currentPage = 1, limit = 10) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        getBrandListing({ page: currentPage, pageSize: limit, search: inputValue })(response => {
          if (response?.statusCode === 200) {
            const results = response?.data?.map(item => ({
              value: item.id,
              label: item.name,
            }));

            // Filter out already selected brands
            const filteredResults = results.filter(
              brand => !selectedBrands.some(selected => selected.value === brand.value)
            );

            if (currentPage === 1) {
              setBrands(filteredResults);
            } else {
              setBrands((prevBrands) => [...prevBrands, ...filteredResults]);
            }

            setHasMore(results.length > 0);
            resolve(filteredResults);
          } else {
            setHasMore(false);
            resolve([]);
          }
        });
      }, 300);
    });
  };

  const loadOptionsBrands = (inputValue) => {
    return fetchBrands(inputValue, 1);
  };

  const handleMenuScrollToBottom = () => {
    if (hasMore) {
      const nextPage = page + 1;
      fetchBrands('', nextPage).then(() => {
        setPage(nextPage);
      });
    }
  };

  const onBrandChange = (selectedOptions) => {
    setSelectedBrands(selectedOptions);
    setBrandError(false); // Clear error on change
    formik.setValues({
      ...formik.values,
      selectedBrands: selectedOptions,
      brandIds: selectedOptions.map(brand => brand.value),
    });
  };


  const removeBrand = (brandToRemove) => {
    const updatedBrands = selectedBrands.filter(brand => brand.value !== brandToRemove.value);
    setSelectedBrands(updatedBrands);

    // Update formik values
    formik.setValues({
      ...formik.values,
      selectedBrands: updatedBrands,
      brandIds: updatedBrands.map(brand => brand.value),
    });
  };


  return (
    <div className="vendor-form-page">
      <style>{`
        /* ===== Typography ===== */
        .vendor-form-page h3 { font-size: 18px !important; font-weight: 600 !important; }
        .vendor-form-page .page-header-sticky h3 { font-weight: 800 !important; letter-spacing: -0.01em; }
        .vendor-form-page h4 { font-size: 15px !important; font-weight: 600 !important; }
        .vendor-form-page h5 { font-size: 14px !important; font-weight: 600 !important; }
        .vendor-form-page h6 { font-size: 12px !important; font-weight: 600 !important; }
        .vendor-form-page p { font-size: 12px; font-weight: 400; }
        .vendor-form-page small, .vendor-form-page .small { font-size: 11px !important; font-weight: 400 !important; }
        .vendor-form-page .fw-bold, .vendor-form-page .fw-bolder { font-weight: 600 !important; }
        .vendor-form-page .fw-semibold { font-weight: 500 !important; }
        .vendor-form-page .btn { font-size: 12px; font-weight: 500; }
        .vendor-form-page .form-label { font-size: 10px !important; margin-bottom: 3px !important; font-weight: 500 !important; color: #475569 !important; letter-spacing: 0.01em; }
        .vendor-form-page .form-control,
        .vendor-form-page .form-select {
          font-size: 11px !important;
          padding: 4px 10px !important;
          min-height: 30px !important;
          height: 30px !important;
          border-radius: 4px !important;
          border-color: #e2e8f0 !important;
        }
        .vendor-form-page textarea.form-control { height: auto !important; min-height: 60px !important; }
        .vendor-form-page .form-control:focus,
        .vendor-form-page .form-select:focus {
          border-color: #008695 !important;
          box-shadow: 0 0 0 3px rgba(0,134,149,0.15) !important;
        }
        .vendor-form-page .invalid-feedbacks,
        .vendor-form-page .invalid-feedback { font-size: 10px !important; font-weight: 400; }

        /* Hide global topbar; page header is the header */
        body:has(.vendor-form-page) #page-topbar { display: none !important; }
        body:has(.vendor-form-page) .page-content {
          padding-top: 0 !important;
          padding-bottom: 24px !important;
        }

        /* Page header pinned at the top */
        .vendor-form-page .page-header-sticky {
          position: fixed !important;
          top: 0 !important;
          left: var(--vz-vertical-menu-width, 208px) !important;
          right: 0 !important;
          width: auto !important;
          padding: 12px clamp(20px, 3vw, 48px) !important;
          margin: 0 !important;
          background: #f9fafb !important;
          border-bottom: 1px solid #e5e7eb !important;
          z-index: 1050 !important;
        }
        .vendor-form-page { padding-top: 68px !important; }

        /* Back button */
        .vendor-form-page .vfp-back-btn {
          display: inline-flex; align-items: center; justify-content: center;
          width: 30px; height: 30px; border-radius: 4px;
          font-size: 16px; color: #475569; background: #fff;
          border: 1px solid #e2e8f0; cursor: pointer;
          flex-shrink: 0;
          transition: all 0.15s ease;
        }
        .vendor-form-page .vfp-back-btn:hover { color: #008695; border-color: #008695; }

        /* Primary + verify buttons */
        .vendor-form-page .request_btn {
          background: #008695 !important;
          border: 1px solid #008695 !important;
          color: #fff !important;
          font-weight: 600 !important;
          height: 34px !important;
          padding: 0 16px !important;
          font-size: 12px !important;
          border-radius: 4px !important;
          display: inline-flex; align-items: center; justify-content: center; gap: 6px;
        }
        .vendor-form-page .request_btn:hover:not(:disabled) {
          background: #006672 !important; border-color: #006672 !important;
        }
        .vendor-form-page .verify-vendor-btn {
          background: #16a34a !important;
          border: 1px solid #16a34a !important;
          color: #fff !important;
          font-weight: 600 !important;
          height: 34px !important;
          padding: 0 14px !important;
          font-size: 12px !important;
          border-radius: 4px !important;
          display: inline-flex !important; align-items: center !important; justify-content: center !important;
          gap: 6px !important;
        }
        .vendor-form-page .verify-vendor-btn:hover:not(:disabled) { background: #15803d !important; border-color: #15803d !important; }
        .vendor-form-page .verify-vendor-btn:disabled { opacity: 0.6; }

        /* Store Image container — stretch to whatever height the left column actually is */
        .vendor-form-page .card-body .row > .col-md-4 > .form-group {
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        .vendor-form-page .image-upload-container {
          flex: 1 1 auto;
          height: auto !important;
          min-height: 200px !important;
        }

        /* Location Map column — stretch to match left column height on desktop */
        .vendor-form-page .vfp-map-col {
          display: flex;
          flex-direction: column;
        }
        .vendor-form-page .vfp-map-box {
          flex: 1 1 auto;
          width: 100%;
          min-height: 240px;
          border-radius: 8px;
          overflow: hidden;
          border: 1px solid #e2e8f0;
        }

        /* ===== Store Timings (desktop) ===== */
        .vendor-form-page [data-section="timings"] .card-body { padding: 10px 12px !important; }
        .vendor-form-page [data-section="timings"] .table {
          margin-bottom: 0 !important;
          font-size: 11px !important;
        }
        .vendor-form-page [data-section="timings"] .table th {
          padding: 8px 6px !important;
          font-size: 10px !important;
          font-weight: 600 !important;
          text-transform: uppercase;
          letter-spacing: 0.03em;
          color: #475569 !important;
          background: #f8fafc !important;
          border-bottom: 1px solid #e2e8f0 !important;
        }
        .vendor-form-page [data-section="timings"] .table td {
          padding: 6px 6px !important;
          font-size: 11px !important;
          vertical-align: middle;
          border-color: #eef2f7 !important;
        }
        .vendor-form-page [data-section="timings"] .badge {
          font-size: 9px !important;
          font-weight: 600 !important;
          padding: 3px 8px !important;
          letter-spacing: 0.02em;
        }
        .vendor-form-page [data-section="timings"] .table input[type="time"] {
          height: 28px !important;
          min-height: 28px !important;
          font-size: 11px !important;
          padding: 2px 6px !important;
          min-width: 96px !important;
          max-width: 116px !important;
          border-radius: 4px !important;
        }
        /* Compact the header row (title + "Apply Monday" button) */
        .vendor-form-page [data-section="timings"] .card-header .subcategory-add-button {
          font-size: 11px !important;
          padding: 4px 10px !important;
          border-radius: 4px !important;
          height: 28px;
          display: inline-flex; align-items: center;
        }

        /* Cards */
        .vendor-form-page .card {
          border: 1px solid #e2e8f0 !important;
          border-radius: 10px !important;
          box-shadow: none !important;
          margin-bottom: 10px !important;
        }
        .vendor-form-page .card-header {
          background: #f8fafc !important;
          padding: 8px 12px !important;
          border-bottom: 1px solid #e2e8f0 !important;
          font-size: 12px !important;
          font-weight: 600 !important;
        }
        .vendor-form-page .card-header h5,
        .vendor-form-page .card-header h4,
        .vendor-form-page .card-header span {
          font-size: 12px !important;
          font-weight: 600 !important;
          margin: 0 !important;
        }
        .vendor-form-page .card-body { padding: 10px 12px !important; }
        .vendor-form-page .mb-4 { margin-bottom: 8px !important; }
        .vendor-form-page .mb-3 { margin-bottom: 8px !important; }
        .vendor-form-page .mb-2 { margin-bottom: 6px !important; }
        .vendor-form-page .form-group { margin-bottom: 8px !important; }

        /* React-select scoped compact styling */
        .vendor-form-page .css-1s2u09g-control,
        .vendor-form-page .css-1pahdxg-control,
        .vendor-form-page .select__control {
          min-height: 30px !important;
          border-color: #e2e8f0 !important;
          font-size: 11px !important;
        }
        .vendor-form-page .select__value-container { padding: 0 8px !important; }
        .vendor-form-page .select__placeholder,
        .vendor-form-page .select__single-value,
        .vendor-form-page .select__input-container { font-size: 11px !important; }

        /* ===== Business uploads: stretch to match left column height on desktop ===== */
        @media (min-width: 768px) {
          .vendor-form-page [data-section="business"] .image-upload-container,
          .vendor-form-page [data-section="business"] [style*="height: 150px"] {
            height: 180px !important;
            min-height: 180px !important;
          }
        }

        /* ===== Modern Store Timings ===== */
        .vendor-form-page .vfp-timings-table-wrap {
          border: 1px solid #eef2f7;
          border-radius: 12px;
          overflow: hidden;
          background: #fff;
        }
        .vendor-form-page .vfp-timings-table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0;
          margin: 0;
        }
        .vendor-form-page .vfp-timings-table thead th {
          background: #f8fafc;
          color: #475569;
          font-size: 10px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.04em;
          padding: 10px 14px;
          border-bottom: 1px solid #eef2f7;
          text-align: left;
          white-space: nowrap;
        }
        .vendor-form-page .vfp-timings-table tbody td {
          padding: 8px 14px;
          border-bottom: 1px solid #f1f5f9;
          font-size: 12px;
          color: #0f172a;
          vertical-align: middle;
        }
        .vendor-form-page .vfp-timings-table tbody tr:last-child td { border-bottom: 0; }
        .vendor-form-page .vfp-timings-table tbody tr.is-closed td { opacity: 0.6; }
        .vendor-form-page .vfp-timings-table .vfp-day-cell {
          font-weight: 600;
          letter-spacing: -0.01em;
        }
        .vendor-form-page .vfp-status-chip {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 3px 10px;
          border-radius: 999px;
          font-size: 10.5px;
          font-weight: 600;
          letter-spacing: 0.01em;
          border: 1px solid transparent;
        }
        .vendor-form-page .vfp-status-chip.is-open {
          background: rgba(34, 197, 94, 0.10);
          color: #15803d;
          border-color: rgba(34, 197, 94, 0.25);
        }
        .vendor-form-page .vfp-status-chip.is-closed {
          background: rgba(148, 163, 184, 0.14);
          color: #64748b;
          border-color: rgba(148, 163, 184, 0.25);
        }
        .vendor-form-page .vfp-status-dot {
          width: 6px; height: 6px; border-radius: 50%;
          background: currentColor;
        }
        .vendor-form-page .vfp-time-input {
          height: 30px !important;
          padding: 4px 8px !important;
          font-size: 12px !important;
          border-radius: 6px !important;
          border: 1px solid #e2e8f0 !important;
          width: 118px !important;
          background: #fff !important;
          color: #0f172a !important;
        }
        .vendor-form-page .vfp-time-input:focus {
          border-color: #008695 !important;
          box-shadow: 0 0 0 3px rgba(0,134,149,0.12) !important;
          outline: none;
        }
        .vendor-form-page .vfp-time-input:disabled {
          background: #f8fafc !important;
          color: #94a3b8 !important;
          cursor: not-allowed;
        }
        .vendor-form-page .vfp-timings-switch .MuiSwitch-root { padding: 4px; }
        .vendor-form-page .vfp-timings-switch .MuiSwitch-track { border-radius: 999px; }
        .vendor-form-page .vfp-timings-cards { display: none; }
        @media (max-width: 767.98px) {
          .vendor-form-page .vfp-timings-table-wrap { display: none; }
          .vendor-form-page .vfp-timings-cards {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }
          .vendor-form-page .vfp-timing-card {
            border: 1px solid #eef2f7;
            border-radius: 12px;
            background: #fff;
            padding: 10px 12px;
            transition: border-color 0.15s ease, background 0.15s ease;
          }
          .vendor-form-page .vfp-timing-card.is-closed { background: #f8fafc; }
          .vendor-form-page .vfp-timing-card-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 8px;
            margin-bottom: 8px;
          }
          .vendor-form-page .vfp-timing-day {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            min-width: 0;
          }
          .vendor-form-page .vfp-day-name {
            font-size: 12.5px;
            font-weight: 700;
            color: #0f172a;
            letter-spacing: -0.01em;
          }
          .vendor-form-page .vfp-timing-card-times {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 8px;
          }
          .vendor-form-page .vfp-timing-field {
            display: flex;
            flex-direction: column;
            gap: 3px;
          }
          .vendor-form-page .vfp-timing-label {
            font-size: 10px;
            font-weight: 600;
            color: #64748b;
            text-transform: uppercase;
            letter-spacing: 0.04em;
          }
          .vendor-form-page .vfp-time-input {
            width: 100% !important;
            height: 34px !important;
            font-size: 12px !important;
          }
          .vendor-form-page .vfp-timing-card.is-closed .vfp-time-input { opacity: 0.55; }
        }

        /* ===== Section tabs (underline style) ===== */
        .vendor-form-page .vfp-tabs {
          display: flex;
          align-items: center;
          gap: 0;
          margin: 0 0 16px 0;
          border-bottom: 1px solid #e2e8f0;
          overflow-x: auto;
          scrollbar-width: none;
        }
        .vendor-form-page .vfp-tabs::-webkit-scrollbar { display: none; }
        .vendor-form-page .vfp-tab {
          position: relative;
          padding: 10px 18px;
          border: none;
          background: transparent;
          font-size: 13px;
          font-weight: 500;
          color: #64748b;
          cursor: pointer;
          flex-shrink: 0;
          transition: color 0.15s ease;
          white-space: nowrap;
        }
        .vendor-form-page .vfp-tab::after {
          content: '';
          position: absolute;
          left: 12px; right: 12px; bottom: -1px;
          height: 2px;
          background: transparent;
          border-radius: 2px 2px 0 0;
          transition: background 0.2s ease;
        }
        .vendor-form-page .vfp-tab:hover:not(.is-active) { color: #0f172a; }
        .vendor-form-page .vfp-tab.is-active {
          color: #008695;
          font-weight: 700;
        }
        .vendor-form-page .vfp-tab.is-active::after { background: #008695; }
        .vendor-form-page .vfp-tab-label-short { display: none; }

        /* Only the active section is visible; others are removed from layout */
        .vendor-form-page .vfp-section { display: none !important; }
        .vendor-form-page .vfp-section.is-active { display: block !important; }

        /* Prev / Next section navigator */
        .vendor-form-page .vfp-section-nav {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          padding: 10px 12px;
          margin: 6px 0 12px;
          background: #f8fafc;
          border: 1px solid #eef2f7;
          border-radius: 10px;
        }
        .vendor-form-page .vfp-nav-btn {
          display: inline-flex; align-items: center; justify-content: center;
          height: 34px;
          padding: 0 14px;
          font-size: 12px;
          font-weight: 600;
          color: #0f172a;
          background: #fff;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.15s ease;
        }
        .vendor-form-page .vfp-nav-btn:hover:not(:disabled) {
          border-color: #008695;
          color: #008695;
          background: rgba(0,134,149,0.06);
        }
        .vendor-form-page .vfp-nav-btn:disabled {
          opacity: 0.35;
          cursor: not-allowed;
        }
        .vendor-form-page .vfp-nav-progress {
          font-size: 11px;
          font-weight: 600;
          color: #64748b;
          letter-spacing: 0.02em;
        }

        @media (max-width: 991px) {
          .vendor-form-page .page-header-sticky { padding: 10px 20px !important; }
        }
        @media (max-width: 767.98px) {
          body:has(.vendor-form-page) .mobile-topbar { display: none !important; }
          body:has(.vendor-form-page) .main-content { padding-top: 0 !important; }
          /* Single horizontal padding (12px) applied at .page-content so every child aligns */
          body:has(.vendor-form-page) .page-content {
            padding-left: 12px !important;
            padding-right: 12px !important;
          }
          body:has(.vendor-form-page) .container,
          body:has(.vendor-form-page) .container-fluid {
            padding-left: 0 !important; padding-right: 0 !important;
            max-width: 100% !important;
          }
          /* Row/col gutter offset so fields align with the page-content edge */
          .vendor-form-page .row { margin-left: -4px !important; margin-right: -4px !important; }
          .vendor-form-page .row > [class*="col-"] { padding-left: 4px !important; padding-right: 4px !important; }
          /* Default: any col-md-6 field goes 50/50 on mobile */
          .vendor-form-page .row > .col-md-6 {
            flex: 0 0 50% !important;
            max-width: 50% !important;
          }
          /* Exception: outer page halves (col-md-6 without a smaller lg override) → full width */
          .vendor-form-page .card-body > .row > .col-md-6:not(.col-lg-4):not(.col-lg-3) {
            flex: 0 0 100% !important;
            max-width: 100% !important;
          }
          /* Bank Details: every field on its own row on mobile */
          .vendor-form-page [data-section="bank"] .row > [class*="col-"] {
            flex: 0 0 100% !important;
            max-width: 100% !important;
          }

          /* Store Timings — extra compact on mobile */
          .vendor-form-page [data-section="timings"] .card-body { padding: 8px 0 !important; }
          .vendor-form-page [data-section="timings"] .card-header {
            flex-wrap: wrap !important;
            gap: 6px !important;
          }
          .vendor-form-page [data-section="timings"] .card-header span { font-size: 12px !important; }
          .vendor-form-page [data-section="timings"] .card-header .subcategory-add-button {
            font-size: 10px !important;
            padding: 4px 8px !important;
            height: 26px;
          }
          .vendor-form-page [data-section="timings"] .table { font-size: 10px !important; }
          .vendor-form-page [data-section="timings"] .table th {
            padding: 6px 4px !important;
            font-size: 9px !important;
          }
          .vendor-form-page [data-section="timings"] .table td {
            padding: 5px 3px !important;
            font-size: 10px !important;
          }
          .vendor-form-page [data-section="timings"] .badge {
            font-size: 8px !important;
            padding: 2px 5px !important;
          }
          .vendor-form-page [data-section="timings"] .table input[type="time"] {
            height: 26px !important;
            min-height: 26px !important;
            font-size: 10px !important;
            padding: 2px 4px !important;
            min-width: 74px !important;
            max-width: 90px !important;
          }
          /* Shrink the switch on mobile */
          .vendor-form-page [data-section="timings"] .custom-switch .MuiSwitch-root {
            transform: scale(0.75);
            margin: -6px;
          }
          /* Basic Info: put the Store Image (col-md-4) at the top on mobile */
          .vendor-form-page .card-body .row > .col-md-4 { order: -1 !important; }
          .vendor-form-page .card-body .row > .col-md-8 { order: 0 !important; }

          .vendor-form-page .page-header-sticky {
            left: 0 !important; right: 0 !important;
            padding: 10px 12px !important;
          }
          .vendor-form-page { padding-top: 58px !important; padding-bottom: calc(76px + env(safe-area-inset-bottom, 0px)) !important; }
          .vendor-form-page .page-header-sticky h3 { font-size: 14px !important; }
          .vendor-form-page .page-header-sticky .vfp-verified-icon { font-size: 16px !important; }

          /* Header primary action → moved to a fixed bottom bar */
          .vendor-form-page .page-header-sticky .request_btn { display: none !important; }
          .vendor-form-page .page-header-sticky .verify-vendor-btn { display: none !important; }

          /* Store Image compact on mobile (desktop rule was 400px min) */
          .vendor-form-page .image-upload-container {
            height: 200px !important;
            min-height: 200px !important;
          }

          /* Underline tabs — compact on mobile */
          .vendor-form-page .vfp-tabs {
            margin: 0 0 12px !important;
          }
          .vendor-form-page .vfp-tab {
            padding: 8px 12px !important;
            font-size: 12px !important;
            flex: 1 1 auto;
          }
          .vendor-form-page .vfp-tab::after { left: 8px !important; right: 8px !important; }
          .vendor-form-page .vfp-tab-label-full { display: none; }
          .vendor-form-page .vfp-tab-label-short { display: inline; }

          .vendor-form-page .vfp-section-nav {
            padding: 8px 10px !important;
            margin: 6px 0 10px !important;
          }
          .vendor-form-page .vfp-nav-btn { height: 32px; padding: 0 10px; font-size: 11px; }
          .vendor-form-page .vfp-nav-progress { font-size: 10px; }

          /* Flatten cards on mobile — no border, no shadow, no rounded corners; act as sections
             (horizontal padding provided by .page-content so everything aligns at the same edge) */
          .vendor-form-page .card {
            border: none !important;
            background: transparent !important;
            border-radius: 0 !important;
            margin-bottom: 6px !important;
            box-shadow: none !important;
          }
          .vendor-form-page .card-header {
            background: transparent !important;
            border: none !important;
            padding: 8px 0 4px !important;
            font-size: 12px !important;
          }
          .vendor-form-page .card-header h5,
          .vendor-form-page .card-header h4 { font-size: 12px !important; }
          .vendor-form-page .card-body { padding: 8px 0 12px !important; }

          .vendor-form-page .form-control,
          .vendor-form-page .form-select { font-size: 12px !important; min-height: 34px !important; }
          .vendor-form-page .form-label { font-size: 10px !important; }

          .vfp-mobile-actions {
            display: flex !important;
          }
        }

        /* Fixed bottom bar (mobile only) */
        .vfp-mobile-actions {
          display: none;
          position: fixed;
          left: 0; right: 0; bottom: 0;
          padding: 10px 12px calc(10px + env(safe-area-inset-bottom, 0px));
          background: #fff;
          border-top: 1px solid #e2e8f0;
          box-shadow: 0 -2px 8px rgba(15,23,42,0.05);
          z-index: 1049;
          gap: 8px;
        }
        .vfp-mobile-actions .btn { flex: 1; height: 44px; font-size: 13px !important; font-weight: 700 !important; border-radius: 6px !important; }
      `}</style>

      <div className="page-header-sticky d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div className="d-flex align-items-center gap-2">
          <button
            type="button"
            className="vfp-back-btn back-btn"
            onClick={() => navigate(-1)}
            aria-label="Back"
          >
            <IoMdArrowBack />
          </button>
          <h3 className="mb-0 fw-bold">{id ? 'Update' : 'Add'} Vendor</h3>
          {store?.isVerified ? (
            <Verified className="vfp-verified-icon" style={{ fontSize: '18px', color: '#16a34a', marginLeft: '2px' }} />
          ) : null}
        </div>

        {!dataLoading && (
          <div className="d-flex align-items-center gap-2 flex-shrink-0">
            <Button
              onClick={() => triggerSubmit('update')}
              disabled={loading}
              className="request_btn flex-shrink-0"
            >
              {loading && loadingIntent === 'update' ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  {id ? 'Updating...' : 'Creating...'}
                </>
              ) : (
                <>
                  <FaCheckDouble size={12} />
                  {id ? 'Update Vendor' : 'Create New Vendor'}
                </>
              )}
            </Button>

            {user?.userType === 'ADMIN' && id && !store?.isVerified && (
              <Button
                onClick={() => triggerSubmit('verify')}
                disabled={loading}
                className="verify-vendor-btn flex-shrink-0"
              >
                {loading && loadingIntent === 'verify' ? (
                  <>
                    <span className="spinner-border spinner-border-sm" />
                    Verifying...
                  </>
                ) : (
                  <>
                    <FiCheck size={14} strokeWidth={3} />
                    Verify Vendor
                  </>
                )}
              </Button>
            )}
          </div>
        )}
      </div>

      {dataLoading ?

        <div className='d-flex justify-content-center align-items-center' style={{ height: '400px' }}>
          <Loader />
        </div>

        : dataError ? (
          <ErrorState
            onRetry={() => {
              setDataError(false)
              getManufacturer()
            }}
          />
        ) : (<Form onSubmit={formik.handleSubmit} autoComplete="off" className="cm-no-autofill">
          {/* Decoy inputs — browsers autofill the first text/password pair they find;
              placing hidden ones at the top absorbs those suggestions so real fields stay empty. */}
          <input
            type="text"
            name="fake_user_decoy"
            autoComplete="username"
            tabIndex={-1}
            aria-hidden="true"
            style={{ position: 'absolute', opacity: 0, pointerEvents: 'none', height: 0, width: 0 }}
          />
          <input
            type="password"
            name="fake_pass_decoy"
            autoComplete="new-password"
            tabIndex={-1}
            aria-hidden="true"
            style={{ position: 'absolute', opacity: 0, pointerEvents: 'none', height: 0, width: 0 }}
          />
          {/* Section tabs */}
          <div className="vfp-tabs" role="tablist">
            {VFP_SECTIONS.map((s) => {
              const isActive = activeSection === s.key;
              return (
                <button
                  key={s.key}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  className={`vfp-tab ${isActive ? 'is-active' : ''}`}
                  onClick={() => setActiveSection(s.key)}
                >
                  <span className="vfp-tab-label-full">{s.label}</span>
                  <span className="vfp-tab-label-short">{s.shortLabel}</span>
                </button>
              );
            })}
          </div>

          {/* Basic Information Card */}
          <Card data-section="basic" className={`mb-4 shadow-null vfp-section ${activeSection === 'basic' ? 'is-active' : ''}`}>

            <Card.Body className="p-4">
              <Row>

                <Row>
                  {/* Left Side - Form Fields (8 columns) */}
                  <Col md={8}>
                    <Row>
                      {/* Store Name - 6 columns on large screens, 12 on smaller */}
                      <Col md={6} lg={6}>
                        <Form.Group className="mb-4">
                          <Form.Label className="fw-semibold">Store Name *</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter store name"
                            name="storeName"
                            value={formik.values?.storeName}
                            onChange={handleInputChange}
                            isInvalid={formik.touched.storeName && !!formik.errors.storeName}
                            className="rounded-input"
                          />
                          <Form.Control.Feedback type="invalid">
                            {formik.errors.storeName}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      {/* Owner Name - 6 columns on large screens, 12 on smaller */}
                      <Col md={6} lg={6}>
                        <Form.Group className="mb-4">
                          <Form.Label className="fw-semibold">Owner Name *</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter owner name"
                            name="ownerName"
                            value={formik.values?.ownerName}
                            onChange={handleInputChange}
                            isInvalid={formik.touched.ownerName && !!formik.errors.ownerName}
                            className="rounded-input"
                          />
                          <Form.Control.Feedback type="invalid">
                            {formik.errors.ownerName}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      {/* Phone Number - 6 columns on large screens, 12 on smaller */}
                      <Col md={6} lg={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className="fw-semibold">Phone Number *</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter phone number"
                            name="phoneNumber"
                            value={formik.values?.phoneNumber}
                            onChange={formik.handleChange}
                            isInvalid={formik.touched.phoneNumber && !!formik.errors.phoneNumber}
                            maxLength={10}
                            className="rounded-input"
                          />
                          <Form.Control.Feedback type="invalid">
                            {formik.errors.phoneNumber}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      {/* Email Address - 6 columns on large screens, 12 on smaller */}
                      <Col md={6} lg={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className="fw-semibold">Email Address *</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Enter email address"
                            name="email"
                            disabled={!!id}
                            value={formik.values?.email}
                            onChange={formik.handleChange}
                            isInvalid={formik.touched.email && !!formik.errors.email}
                            className="rounded-input"
                          />
                          <Form.Control.Feedback type="invalid">
                            {formik.errors.email}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Form.Group className="mb-4">
                        <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                          Brands associated *
                        </Form.Label>


                        <AsyncSelect
                          isMulti
                          loadOptions={loadOptionsBrands}
                          defaultOptions={brands}
                          classNamePrefix="select"
                          isClearable={true}
                          placeholder="Search and select brands"
                          onChange={onBrandChange}
                          value={selectedBrands}
                          onMenuScrollToBottom={handleMenuScrollToBottom}
                          noOptionsMessage={() => "Type to search brands"}
                          styles={{
                            menu: (base) => ({ ...base, zIndex: 9999 }),
                            control: (base) => ({
                              ...base,
                              border: "1px solid #ced4da",
                              borderRadius: "8px",
                              minHeight: "40px",
                              fontSize: "13px",
                            }),
                            valueContainer: (base) => ({
                              ...base,
                              display: "flex",
                              flexWrap: "nowrap",
                              overflowX: "auto",
                              overflowY: "hidden",
                              scrollbarWidth: "none",
                              msOverflowStyle: "none",
                              "::-webkit-scrollbar": {
                                display: "none",
                              },
                            }),
                            input: (base) => ({
                              ...base,
                              minWidth: "80px",
                              flexShrink: 0,
                            }),
                            multiValue: (base) => ({
                              ...base,
                              backgroundColor: "#288d9dff", // purple
                              color: "white",
                              borderRadius: "12px",
                              padding: "0 4px",
                              flexShrink: 0,
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              color: "white",
                              fontSize: "12px",
                            }),
                            multiValueRemove: (base) => ({
                              ...base,
                              color: "white",
                              ':hover': {
                                backgroundColor: "#288d9dff",
                                color: "white",
                              },
                            }),
                          }}
                        />

                        <div className="invalid-feedbacks mr-2" style={{ color: "#DC3544", fontSize: "12px" }}>
                          {(brandError || (selectedBrands.length === 0 && formik.submitCount > 0)) && <>

                            At least one brand is required
                          </>}
                        </div>


                      </Form.Group>

                      {/* Description — placed below Brands, keeps left side of the image */}
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Description</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Enter store description"
                          name="description"
                          value={formik.values?.description}
                          onChange={formik.handleChange}
                          className="rounded-input"
                        />
                      </Form.Group>

                    </Row>
                  </Col>

                  {/* Right Side - Image Upload (4 columns) */}
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold">Store Image</Form.Label>
                      <div
                        className="image-upload-container position-relative rounded p-2 text-center"
                        onClick={() => document.getElementById('storeImage').click()}
                        style={{
                          cursor: 'pointer',
                          height: '230px',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: '2px dashed #d1d1d1ff', // ✅ Dashed border
                          transition: 'all 0.3s ease',
                          overflow: 'hidden',
                          borderRadius: '16px',
                        }}
                      >
                        {formik.values.img_view ? (
                          <>
                            <img
                              src={formik.values.img_view}
                              alt="Store"
                              className="img-fluid h-150 w-100"
                              style={{
                                objectFit: 'cover'
                              }}
                            />
                            {/* Hover Overlay */}
                            <div
                              className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
                              style={{
                                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                opacity: 0,
                                transition: 'opacity 0.3s ease',
                                color: 'white'
                              }}
                              onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
                              onMouseLeave={(e) => (e.currentTarget.style.opacity = '0')}
                            >
                              <FiUploadCloud size={24} className="mb-1" />
                              <small>Change image</small>
                            </div>
                          </>
                        ) : (
                          <>
                            <FiUploadCloud size={28} className="text-muted mb-2" />
                            <p className="text-muted mb-1 small">Click to upload store image</p>

                          </>
                        )}
                      </div>
                      <Form.Control
                        id="storeImage"
                        type="file"
                        onChange={handleImageChange}
                        isInvalid={formik.touched.img_view && formik.errors.img_view}
                        style={{ display: 'none' }}
                        accept="image/*"
                      />
                      <Form.Control.Feedback type="invalid">
                        {formik.errors.img_view}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                </Row>
              </Row>
            </Card.Body>
          </Card>

          {/* Location Information Card */}
          <Card data-section="location" className={`mb-4 shadow-sm vfp-section ${activeSection === 'location' ? 'is-active' : ''}`}>
            <Card.Header className="bg-light">
              <span
                style={{
                  fontSize: '16px',
                  fontWeight: '700',
                }}
              >
                Location Information
              </span>
            </Card.Header>
            <Card.Body className="p-4">
              <Row>
                {/* Left Column - Location Form Fields (includes Search Location) */}
                <Col md={12} lg={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Search Location *</Form.Label>
                    {script && (
                      <GooglePlacesAutocomplete
                        selectProps={{
                          placeholder: 'Type your location...',
                          value,
                          onChange: changeValue,
                          noOptionsMessage: () => 'No locations found',
                          styles: {
                            control: (base) => ({
                              ...base,
                              border: '1px solid #e2e8f0',
                              borderRadius: '4px',
                              minHeight: '30px',
                              fontSize: '11px',
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: '#94a3b8',
                              fontSize: '11px',
                            }),
                          },
                        }}
                      />
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Address *</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter complete address"
                      name="address"
                      value={formik.values?.address}
                      onChange={handleInputChange}
                      isInvalid={formik.touched.address && !!formik.errors.address}
                      className="rounded-input"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.address}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">State *</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter state"
                          name="state"
                          value={formik.values?.state}
                          onChange={handleInputChange}
                          isInvalid={formik.touched.state && !!formik.errors.state}
                          className="rounded-input"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.state}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">City *</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter city"
                          name="city"
                          value={formik.values?.city}
                          onChange={handleInputChange}
                          isInvalid={formik.touched.city && !!formik.errors.city}
                          className="rounded-input"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.city}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Pincode *</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter pincode"
                          name="postalcode"
                          value={formik.values?.postalcode}
                          onChange={handleInputChange}
                          isInvalid={formik.touched.postalcode && !!formik.errors.postalcode}
                          className="rounded-input"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.postalcode}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Landmark</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter landmark"
                          name="landmark"
                          value={formik.values?.landmark}
                          onChange={handleInputChange}
                          isInvalid={formik.touched.landmark && !!formik.errors.landmark}
                          className="rounded-input"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.landmark}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>

                {/* Right Column - Map (fills full column height on desktop) */}
                <Col md={12} lg={6} className="vfp-map-col">
                  <Form.Label className="fw-semibold">Location Map</Form.Label>
                  <div className="vfp-map-box">
                    {script && (
                      <GoogleMap
                        bootstrapURLKeys={{ key: GOOGLE_MAP_API_KEY }}
                        defaultZoom={15}
                        center={mapCenter}
                        yesIWantToUseGoogleMapApiInternals
                      >
                        <div
                          lat={mapCenter.lat}
                          lng={mapCenter.lng}
                          style={{ color: 'red', fontSize: '32px' }}
                        >
                          <FaMapMarkerAlt className="marker_icon bounce" />
                        </div>
                      </GoogleMap>
                    )}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>


          {/* Business Details Card */}
          <Card data-section="business" className={`mb-4 shadow-sm vfp-section ${activeSection === 'business' ? 'is-active' : ''}`}>
            <Card.Header className="bg-light">
              <span
                style={{
                  fontSize: '16px',
                  fontWeight: '700',
                }}
              >
                Business details
              </span>
            </Card.Header>
            <Card.Body className="p-4">
              <Row>

                <Col md={12} lg={5}>

                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <Form.Label className="fw-semibold">Business name on GST Document</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter business name"
                        name="businessName"
                        value={formik.values?.businessName}
                        onChange={handleInputChange}
                        isInvalid={formik.touched.businessName && !!formik.errors.businessName}

                        className="rounded-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        {formik.errors.businessName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>


                  {/* PAN + GST (side-by-side on mobile, stacked on desktop) */}
                  <Row>
                    <Col xs={6} md={12}>
                      <Form.Group className="mb-4">
                        <Form.Label className="fw-semibold">PAN Number</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter PAN number"
                          name="pan"
                          value={formik.values?.pan}
                          onChange={formik.handleChange}
                          isInvalid={formik.touched.pan && !!formik.errors.pan}
                          maxLength={10}
                          className="rounded-input"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.pan}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col xs={6} md={12}>
                      <Form.Group className="mb-4">
                        <Form.Label className="fw-semibold">GST Number</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter GST number"
                          name="gst"
                          value={formik.values?.gst}
                          onChange={handleInputChange}
                          isInvalid={formik.touched.gst && !!formik.errors.gst}
                          maxLength={15}
                          className="rounded-input"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.gst}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row md={12}>

                    {/* Commission */}
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Commission % *</Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Enter commission percentage"
                          name="commission"
                          value={formik.values?.commission}
                          onChange={formik.handleChange}
                          isInvalid={formik.touched.commission && !!formik.errors.commission}
                          min={0}
                          max={100}
                          step="any"
                          readOnly={user?.userType !== 'ADMIN'}
                          className="rounded-input"
                          style={user?.userType !== 'ADMIN' ? { backgroundColor: '#f8f9fa' } : {}}
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.commission}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {/* New GST Applicable Field */}
                    {user?.userType === 'ADMIN' && (<Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">GST Applicable *</Form.Label>
                        <Form.Select
                          name="gstApplicable"
                          value={formik.values?.gstApplicable}
                          onChange={formik.handleChange}
                          isInvalid={formik.touched.gstApplicable && !!formik.errors.gstApplicable}
                          className="rounded-input"
                        >

                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">

                          {formik.errors.gstApplicable}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>)}

                  </Row>



                </Col>



                {/* Right side - Document Uploads */}
                <Col md={12} lg={7}>
                  <Row>
                    {/* PAN Copy */}
                    <Col xs={12} md={4} className="mb-2">
                      <Form.Group>
                        <Form.Label className="fw-semibold">PAN Copy</Form.Label>

                        <div
                          className="position-relative rounded d-flex align-items-center justify-content-center"
                          onClick={() => document.getElementById('panCopy').click()}
                          style={{
                            height: '150px',
                            border: '2px dashed #d1d1d1',
                            cursor: 'pointer'
                          }}
                        >
                          {formik.values.pan_copy_view ? (
                            <>
                              <img
                                src={formik.values.pan_copy_view}
                                alt="PAN Copy"
                                className="w-100 h-100 rounded"
                                style={{ objectFit: 'cover' }}
                              />

                              <div className="position-absolute top-0 end-0 m-2 d-flex gap-2">
                                {/* View */}
                                <div
                                  title="View"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openPreview(formik.values.pan_copy_view);
                                  }}
                                  style={{
                                    width: '26px',
                                    height: '26px',
                                    borderRadius: '50%',
                                    backgroundColor: 'rgba(0,0,0,0.6)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer'
                                  }}
                                >
                                  <BsEye size={10} className="text-white" />
                                </div>

                                {/* Download */}
                                <div
                                  title="Download"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    downloadImage(formik.values.pan_copy_view, 'PAN_Copy');
                                  }}
                                  style={{
                                    width: '26px',
                                    height: '26px',
                                    borderRadius: '50%',
                                    backgroundColor: 'rgba(0,0,0,0.6)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer'
                                  }}
                                >
                                  <BsDownload size={10} className="text-white" />
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="text-center">
                              <FiUploadCloud size={24} className="text-muted mb-2" />
                              <p className="text-muted small mb-0">Click to upload PAN copy</p>
                            </div>
                          )}
                        </div>

                        <Form.Control
                          id="panCopy"
                          type="file"
                          onChange={handleImageChange}
                          style={{ display: 'none' }}
                          accept="image/*"
                        />
                      </Form.Group>
                    </Col>

                    {/* GST Copy */}
                    <Col xs={12} md={4} className="mb-2">
                      <Form.Group>
                        <Form.Label className="fw-semibold">GST Copy</Form.Label>

                        <div
                          className="position-relative rounded d-flex align-items-center justify-content-center"
                          onClick={() => document.getElementById('gstCopy').click()}
                          style={{
                            height: '150px',
                            border: '2px dashed #d1d1d1',
                            cursor: 'pointer'
                          }}
                        >
                          {formik.values.gst_copy_view ? (
                            <>
                              <img
                                src={formik.values.gst_copy_view}
                                alt="GST Copy"
                                className="w-100 h-100 rounded"
                                style={{ objectFit: 'cover' }}
                              />

                              <div className="position-absolute top-0 end-0 m-2 d-flex gap-2">
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openPreview(formik.values.gst_copy_view);
                                  }}
                                  style={{
                                    width: '26px',
                                    height: '26px',
                                    borderRadius: '50%',
                                    backgroundColor: 'rgba(0,0,0,0.6)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer'
                                  }}
                                >
                                  <BsEye size={10} className="text-white" />
                                </div>

                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    downloadImage(formik.values.gst_copy_view, 'GST_Copy');
                                  }}
                                  style={{
                                    width: '26px',
                                    height: '26px',
                                    borderRadius: '50%',
                                    backgroundColor: 'rgba(0,0,0,0.6)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer'
                                  }}
                                >
                                  <BsDownload size={10} className="text-white" />
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="text-center">
                              <FiUploadCloud size={24} className="text-muted mb-2" />
                              <p className="text-muted small mb-0">Click to upload GST copy</p>
                            </div>
                          )}
                        </div>

                        <Form.Control
                          id="gstCopy"
                          type="file"
                          onChange={handleImageChange}
                          style={{ display: 'none' }}
                          accept="image/*"
                        />
                      </Form.Group>
                    </Col>

                    {/* Cancelled Cheque */}
                    <Col xs={12} md={4} className="mb-2">
                      <Form.Group>
                        <Form.Label className="fw-semibold">Cancelled cheque copy</Form.Label>

                        <div
                          className="position-relative rounded d-flex align-items-center justify-content-center"
                          onClick={() => document.getElementById('cancelledChequeCopy').click()}
                          style={{
                            height: '150px',
                            border: '2px dashed #d1d1d1',
                            cursor: 'pointer'
                          }}
                        >
                          {formik.values.cancelled_cheque_view ? (
                            <>
                              <img
                                src={formik.values.cancelled_cheque_view}
                                alt="Cancelled Cheque"
                                className="w-100 h-100 rounded"
                                style={{ objectFit: 'cover' }}
                              />

                              <div className="position-absolute top-0 end-0 m-2 d-flex gap-2">
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openPreview(formik.values.cancelled_cheque_view);
                                  }}
                                  style={{
                                    width: '26px',
                                    height: '26px',
                                    borderRadius: '50%',
                                    backgroundColor: 'rgba(0,0,0,0.6)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer'
                                  }}
                                >
                                  <BsEye size={10} className="text-white" />
                                </div>

                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    downloadImage(
                                      formik.values.cancelled_cheque_view,
                                      'Cancelled_Cheque'
                                    );
                                  }}
                                  style={{
                                    width: '26px',
                                    height: '26px',
                                    borderRadius: '50%',
                                    backgroundColor: 'rgba(0,0,0,0.6)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer'
                                  }}
                                >
                                  <BsDownload size={10} className="text-white" />
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="text-center">
                              <FiUploadCloud size={24} className="text-muted mb-2" />
                              <p className="text-muted small mb-0">
                                Click to upload Cancelled Cheque copy
                              </p>
                            </div>
                          )}
                        </div>

                        <Form.Control
                          id="cancelledChequeCopy"
                          type="file"
                          onChange={handleImageChange}
                          style={{ display: 'none' }}
                          accept="image/*"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>




              </Row>
            </Card.Body>
          </Card>

          {/* Bank Details Card */}
          <Card data-section="bank" className={`mb-4 shadow-sm vfp-section ${activeSection === 'bank' ? 'is-active' : ''}`}>
            <Card.Header className="bg-light">
              <span style={{

                fontSize: '16px',
                fontWeight: '700',


              }}>
                Bank details
              </span>
            </Card.Header>
            <Card.Body className="p-4">
              <Row>
                <Col md={6} lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Bank Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter bank name"
                      name="bankName"
                      value={formik.values?.bankName}
                      onChange={handleInputChange}
                      isInvalid={formik.touched.bankName && !!formik.errors.bankName}
                      className="rounded-input"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.bankName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6} lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Account Type</Form.Label>
                    <Form.Select
                      name="accountType"
                      value={formik.values.accountType}
                      onChange={formik.handleChange}
                      isInvalid={formik.touched.accountType && !!formik.errors.accountType}
                      className="rounded-input"
                    >
                      <option value="">Select account type</option>
                      <option value="Savings">Savings</option>
                      <option value="Current">Current</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.accountType}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6} lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Account Holder Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter account holder name"
                      name="accountHolderName"
                      value={formik.values?.accountHolderName}
                      onChange={formik.handleChange}
                      isInvalid={formik.touched.accountHolderName && !!formik.errors.accountHolderName}
                      className="rounded-input"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.accountHolderName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6} lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Account Number</Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="text"
                        placeholder="Enter account number"
                        name="accountNumber"
                        value={formik.values?.accountNumber}
                        onChange={formik.handleChange}
                        isInvalid={formik.touched.accountNumber && !!formik.errors.accountNumber}
                        className="rounded-input"
                      />
                      {/* <span
                      className="position-absolute top-50 end-0 translate-middle-y me-3"
                      style={{ cursor: 'pointer' }}
                      onClick={() => toggleaccountNumberVisibility("accountNumber")}
                    >
                      {showaccnumber.accountNumber ? <BsEye /> : <BsEyeSlash />}
                    </span> */}
                    </div>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.accountNumber}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6} lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Re-enter Account Number</Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="text"
                        placeholder="Re-enter account number"
                        name="reaccountNumber"
                        value={formik.values?.reaccountNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        isInvalid={formik.touched.reaccountNumber && !!formik.errors.reaccountNumber}
                        className="rounded-input pe-5"
                        autoComplete="new-password"
                        style={showaccnumber.reaccountNumber
                          ? undefined
                          : { WebkitTextSecurity: 'disc', MozTextSecurity: 'disc', textSecurity: 'disc' }
                        }
                      />
                      <span
                        className="position-absolute top-50 end-0 translate-middle-y me-3"
                        style={{ cursor: 'pointer' }}
                        onClick={() => toggleaccountNumberVisibility("reaccountNumber")}
                      >
                        {showaccnumber.reaccountNumber ? <BsEye /> : <BsEyeSlash />}
                      </span>
                    </div>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.reaccountNumber}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6} lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">IFSC Code</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter IFSC code"
                      name="ifscCode"
                      value={formik.values?.ifscCode}
                      onChange={formik.handleChange}
                      isInvalid={formik.touched.ifscCode && !!formik.errors.ifscCode}
                      maxLength={11}
                      className="rounded-input"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.ifscCode}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>


          {/* Store Timings Card - Table Layout */}
          <Card data-section="timings" className={`mb-4 vfp-section ${activeSection === 'timings' ? 'is-active' : ''}`}>
            <Card.Header className="bg-light d-flex justify-content-between align-items-center">
              <span style={{ fontSize: '16px', fontWeight: '700' }}>
                Store Timings
              </span>

              <Button
                onClick={() => {
                  const mondayTiming = formik.values.storeTimings.find(t => t.day === "Monday");
                  if (mondayTiming) {
                    const updatedTimings = formik.values.storeTimings.map(timing =>
                      timing.day !== "Monday"
                        ? {
                          ...timing,
                          openingTime: mondayTiming.openingTime,
                          closingTime: mondayTiming.closingTime,
                        }
                        : timing
                    );
                    formik.setFieldValue("storeTimings", updatedTimings);
                  }
                }}
                variant="outline-dark"
                className="subcategory-add-button fs-8"
              >
                Apply Monday timing to all
              </Button>

            </Card.Header>

            <Card.Body className="p-4">
              {/* Desktop table */}
              <div className="vfp-timings-table-wrap">
                <table className="vfp-timings-table">
                  <thead>
                    <tr>
                      <th>Day</th>
                      <th>Status</th>
                      <th>Opening Time</th>
                      <th>Closing Time</th>
                      <th className="text-end">Toggle</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formik.values.storeTimings.map((timing, index) => (
                      <tr key={index} className={`vfp-timings-row ${timing?.isActive ? 'is-open' : 'is-closed'}`}>
                        <td className="vfp-day-cell">{timing.day}</td>
                        <td>
                          <span className={`vfp-status-chip ${timing?.isActive ? 'is-open' : 'is-closed'}`}>
                            <span className="vfp-status-dot" />
                            {timing?.isActive ? 'Open' : 'Closed'}
                          </span>
                        </td>
                        <td>
                          <Form.Control
                            type="time"
                            name={`storeTimings.${index}.openingTime`}
                            value={formik.values.storeTimings[index].openingTime}
                            onChange={formik.handleChange}
                            disabled={!timing?.isActive}
                            className="vfp-time-input"
                          />
                        </td>
                        <td>
                          <Form.Control
                            type="time"
                            name={`storeTimings.${index}.closingTime`}
                            value={formik.values.storeTimings[index].closingTime}
                            onChange={formik.handleChange}
                            disabled={!timing?.isActive}
                            className="vfp-time-input"
                          />
                        </td>
                        <td className="text-end">
                          <Switch
                            size="small"
                            id={`custom-switch-${index}`}
                            checked={timing?.isActive}
                            onChange={() => statusActive(timing?.id, timing?.isActive, index)}
                            className="vfp-timings-switch"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Mobile cards */}
              <div className="vfp-timings-cards">
                {formik.values.storeTimings.map((timing, index) => (
                  <div key={index} className={`vfp-timing-card ${timing?.isActive ? 'is-open' : 'is-closed'}`}>
                    <div className="vfp-timing-card-top">
                      <div className="vfp-timing-day">
                        <span className="vfp-day-name">{timing.day}</span>
                        <span className={`vfp-status-chip ${timing?.isActive ? 'is-open' : 'is-closed'}`}>
                          <span className="vfp-status-dot" />
                          {timing?.isActive ? 'Open' : 'Closed'}
                        </span>
                      </div>
                      <Switch
                        size="small"
                        id={`custom-switch-mobile-${index}`}
                        checked={timing?.isActive}
                        onChange={() => statusActive(timing?.id, timing?.isActive, index)}
                        className="vfp-timings-switch"
                      />
                    </div>
                    <div className="vfp-timing-card-times">
                      <div className="vfp-timing-field">
                        <label className="vfp-timing-label">Opening</label>
                        <Form.Control
                          type="time"
                          name={`storeTimings.${index}.openingTime`}
                          value={formik.values.storeTimings[index].openingTime}
                          onChange={formik.handleChange}
                          disabled={!timing?.isActive}
                          className="vfp-time-input"
                        />
                      </div>
                      <div className="vfp-timing-field">
                        <label className="vfp-timing-label">Closing</label>
                        <Form.Control
                          type="time"
                          name={`storeTimings.${index}.closingTime`}
                          value={formik.values.storeTimings[index].closingTime}
                          onChange={formik.handleChange}
                          disabled={!timing?.isActive}
                          className="vfp-time-input"
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Card.Body>
          </Card>

          {/* Section nav — Prev / Next */}
          <div className="vfp-section-nav">
            <button
              type="button"
              className="vfp-nav-btn vfp-nav-prev"
              onClick={goPrevSection}
              disabled={activeSectionIndex === 0}
            >
              ← Previous
            </button>
            <span className="vfp-nav-progress">
              Step {activeSectionIndex + 1} of {VFP_SECTIONS.length}
            </span>
            <button
              type="button"
              className="vfp-nav-btn vfp-nav-next"
              onClick={goNextSection}
              disabled={activeSectionIndex === VFP_SECTIONS.length - 1}
            >
              Next →
            </button>
          </div>

        </Form>)}



      <Modal
        show={showPreview}
        onHide={closePreview}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Document Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {previewImage && (
            <img
              src={previewImage}
              alt="Preview"
              style={{
                width: '100%',
                maxHeight: '70vh',
                objectFit: 'contain',
                borderRadius: '12px',
              }}
            />
          )}
        </Modal.Body>
      </Modal>


      <style jsx>{`
        
        .rounded-input {
          border-radius: 16px;
        }
        .image-upload-container {
          transition: all 0.3s ease;
          border: 2px dashed #dee2e6;
        }
        .image-upload-container:hover {
          border-color: #0d6efd;
          background-color: #f8f9fa;
        }
        .marker_icon {
          animation: bounce 1s infinite;
        }
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        .store-timings-display {
          max-height: 300px;
          overflow-y: auto;
        }
        .store-timings-edit .accordion-button:not(.collapsed) {
          background-color: #f8f9fa;
          color: #000;
        }
      `}</style>

      {/* Fixed bottom action bar — mobile only */}
      {!dataLoading && (
        <div className="vfp-mobile-actions">
          <Button
            onClick={() => triggerSubmit('update')}
            disabled={loading}
            className="request_btn"
          >
            {loading && loadingIntent === 'update' ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                {id ? 'Updating…' : 'Creating…'}
              </>
            ) : (
              <>
                <FaCheckDouble size={14} />
                {id ? 'Update Vendor' : 'Create New Vendor'}
              </>
            )}
          </Button>
          {user?.userType === 'ADMIN' && id && !store?.isVerified && (
            <Button
              onClick={() => triggerSubmit('verify')}
              disabled={loading}
              className="verify-vendor-btn"
            >
              {loading && loadingIntent === 'verify' ? (
                <>
                  <span className="spinner-border spinner-border-sm" />
                  Verifying…
                </>
              ) : (
                <>
                  <FiCheck size={14} strokeWidth={3} />
                  Verify
                </>
              )}
            </Button>
          )}
        </div>
      )}
    </div>

  )


}

export default CreateManufacturer
